import { render } from "./Download.vue?vue&type=template&id=343b99c5"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
script.render = render

export default script